import { createVuetify } from 'vuetify';

export default defineNuxtPlugin((nuxtApp) => {
    const dancefloorDarkTheme = {
        dark: true,
        colors: {
            'background': '#0a0a12',
            'surface': '#141424',
            'surface-bright': '#22223a',
            'surface-variant': '#1e1e32',
            'on-surface-variant': '#eeeeff',
            'primary': '#00f0ff',
            'primary-darken-1': '#00b0bd',
            'secondary': '#ff0077',
            'accent': '#39ff14',
            'error': '#ff2a55',
            'info': '#00d0ff',
            'success': '#00ff88',
            'warning': '#ffaa00',
        },
    };

    const vuetify = createVuetify({
        ssr: false,
        theme: {
            defaultTheme: 'dancefloorDarkTheme',
            themes: {
                dancefloorDarkTheme,
            },
        },
    });

    nuxtApp.vueApp.use(vuetify);
});
